<template>
  <b-modal
    ref="profileModal"
    :title="$t('PROFILE_MODAL_TITLE')"
    hide-footer
    size="xl"
    no-close-on-backdrop>
    <b-tabs>
      <profile-invoices-tab />
    </b-tabs>
  </b-modal>
</template>

<script>
import ProfileInvoicesTab from './ProfileInvoicesTab.vue';

export default
{
    name: 'profile-modal',
    components:
    {
        'profile-invoices-tab': ProfileInvoicesTab,
    },
    methods:
    {
        show()
        {
            this.$refs.profileModal.show();
        },
        hide()
        {
            this.$refs.profileModal.hide();
        },
    },
};
</script>
